import { render, staticRenderFns } from "./ViewProviders.vue?vue&type=template&id=6c6a601c"
import script from "./ViewProviders.vue?vue&type=script&lang=js"
export * from "./ViewProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports